import { css } from 'styled-components';
/**
 * Returns the aspect ratio of the given width and height as a percentage.
 */
export function aspectRatio(width, height) {
    return (height / width) * 100;
}
/**
 * Re-usable styles for image container where the
 * image needs to maintain it's aspect ratio
 *
 * @param width
 * @param height
 * @returns
 */
export function imageWrapperPreserveRatio(width, height) {
    if (!width && !height) {
        return null;
    }
    return css `
    position: relative;
    height: 0;
    width: 100%;
    overflow: hidden;
    overflow: clip;
    padding-bottom: ${aspectRatio(width, height)}%;
  `;
}
/**
 * Re-usable styles for an image placed within
 * a container maintaining aspect ratio
 */
export const imageCoverContainer = (relative) => css `
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  ${!relative && 'position: absolute; top: 0;left: 0;'}
`;
